import { Record } from 'immutable'

const DatasourceRecord = Record({
  id: undefined,
  order: undefined,
  name: undefined,
})

export default DatasourceRecord
